module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/camera_country_house-9f7c3a6d33dad8d5f4e1d4ce6026ff27.webp";